import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-5v7a1 1 0 1 1-2 0v-7h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM12 6v2H4v12h14a2 2 0 0 1-2 2h-5v7a1 1 0 1 1-2 0v-7H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 8.914v-2.83l-2.5 2.501-.793-.792-.094-.083a1 1 0 0 0-1.32 1.497l1.5 1.5.094.083a1 1 0 0 0 1.32-.083zM28 4H16v12h12zm-2.71 5.113a1 1 0 0 0-1.497-1.32L21 10.585l-.793-.792-.094-.083a1 1 0 0 0-1.32 1.497l1.5 1.5.094.083a1 1 0 0 0 1.32-.083l3.5-3.5z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconBids = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconBids);
export default Memo;
